import React, { ReactNode } from "react";
import { Tooltip } from "antd";
import { PriceValidationStatus } from "../../lib/types";
import { ReactComponent as NotDefined } from "../../img/not-defined.svg";
import { ReactComponent as Equal } from "../../img/equal.svg";
import { ReactComponent as Updated } from "../../img/updated.svg";
import { ReactComponent as Less } from "../../img/less.svg";
import { ReactComponent as More } from "../../img/more.svg";
import { ReactComponent as Exclamation } from "../../img/exclamation.svg";

interface PriceItemValidationIconProps {
  priceItemValidationStatus?: PriceValidationStatus;
  title?: string;
}

export const PriceItemValidationIcon = (props: PriceItemValidationIconProps) => {
  const { priceItemValidationStatus, title } = props;

  const iconsMap: Record<PriceValidationStatus, ReactNode> = {
    equal: <Equal />,
    updated: <Updated style={{ color: "#00AAFF" }} />,
    increased: <More style={{ color: "#00AAFF" }} />,
    decreased: <Less style={{ color: "red" }} />,
    earlierDate: <Updated style={{ color: "red" }} />,
    laterDate: <Updated style={{ color: "#00AAFF" }} />,
    error: <Exclamation style={{ color: "red" }} />,
    notDefined: <NotDefined />,
  };

  return priceItemValidationStatus ? (
    <Tooltip title={title}>
      <div style={{ marginTop: "5px" }}>{iconsMap[priceItemValidationStatus]}</div>
    </Tooltip>
  ) : null;
};
